export default "__VITE_ASSET__f18e18b8__"